// 列表项课程

import keys from 'lodash.keys'
import style from '@style/course.module.scss'

const dataTypeMap = {
  recommend: {
    image: 'imageUrl',
    title: 'title',
    desc: 'recommendWord',
    price: 'priceStr',
    count: 'subscribeCountStr'
  },
  list: {
    image: 'teacherImage',
    title: 'name',
    desc: 'description',
    price: 'price',
    count: '%count%人已订阅'
  }
}

const getMap = (dataSource, dataType) => {
  const map = dataTypeMap[dataType]
  return keys(map).reduce((result, key) => {
    const value = map[key]
    const match = value.match(/%([\w\d]+)%/)
    result[key] = match ? value.replace(match[0], dataSource[match[1]]) : dataSource[value]
    return result
  }, {})
}

export default {
  props: ['dataSource', 'dataType', 'styleType'],

  render () {
    const {
      dataSource, // from this.props
      dataType, // from this.props
      styleType // from this.props
    } = this

    const map = getMap(dataSource, dataType)

    return (
      <div
        class={{
          [style.courseItem]: true,
          [style[`courseItemType${styleType}`]]: true
        }}
        onClick={() => this.$emit('click')}
      >
        <img
          class={style.courseItemAvatar}
          src={map.image}
          alt={map.title}
        />
        <div class={style.courseItemContent}>
          <h3 class={style.courseItemTitle}>{map.title}</h3>
          <p class={style.courseItemDesc}>{map.desc}</p>
          <div class={style.courseItemBottom}>
            <span class={style.courseItemBottomPrice}>{map.price && map.price !== '' ? `￥${map.price}` : ''}</span>
            <span class={style.courseItemBottomSeperate} />
            <span class={style.courseItemBottomCount}>{map.count}</span>
          </div>
        </div>
      </div>
    )
  }
}
